import { withSizeContext } from './contexts/size';
import { EmptyState as BaseEmptyState } from './empty-state';

export { EmptyStateSize } from './contexts/size';
export { MenuIcons, SurfaceIcons } from './default-icons';

export * from './components';

export const EmptyState = withSizeContext(BaseEmptyState);
